import { ConnectedWallet } from '../../../../assets/constant/kit.type';
import CommentInput, { CommentInputProps } from '../../../../components/_atom/input/CommentInput';
import React, { useEffect, useState } from 'react';
import Checkbox from '../../../../components/_atom/checkbox/Checkbox';
import FileDragAndDrop from '../../../../components/_atom/file/FileDragAndDrop';

const METADATA_EXTENSION = {
  'image/*': ['.png', '.jpeg', '.gif', '.jpg', '.svg', '.webp'],
};
type InputAreaProps = {
  label: string;
  inputType: string;
  setValue: (value: any) => void;
  connectedWallet: ConnectedWallet;
} & CommentInputProps;
const InputArea = (props: InputAreaProps) => {
  const { label, inputType, value, setValue, disabled, connectedWallet, ...rest } = props;
  const [isValueFixed, setIsValueFixed] = useState(true);
  useEffect(() => {
    if (inputType === 'address_optional' && connectedWallet.connectAddress) {
      setValue(connectedWallet.connectAddress);
    }
  }, [connectedWallet]);
  if (inputType === 'file') {
    return (
      <div className="kit-label-value-wrapper column">
        <div className="kit-label">{label}</div>
        <FileDragAndDrop file={value} setFile={setValue} placeholder={'Image File Only / Max 10MB'} accept={METADATA_EXTENSION} disabled={disabled} />
      </div>
    );
  }
  if (inputType === 'address_optional') {
    return (
      <div className="kit-label-value-wrapper column">
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <div className="kit-label" style={{ minWidth: 'fit-content' }}>
            {label}
          </div>
          <Checkbox
            id={'check'}
            style={{ marginRight: 5 }}
            label={'Change Sender'}
            labelStyle={{ fontSize: 14, lineHeight: '100%', color: '#7F879E' }}
            checked={!isValueFixed}
            onChange={() => {
              if (!isValueFixed) {
                setValue(connectedWallet.connectAddress);
              }
              setIsValueFixed(!isValueFixed);
            }}
          />
        </div>
        <CommentInput value={value} disabled={disabled || isValueFixed} {...rest} />
      </div>
    );
  }
  return (
    <div className="kit-label-value-wrapper column">
      <div className="kit-label">{label}</div>
      <CommentInput value={value} disabled={disabled} {...rest} />
    </div>
  );
};

export default InputArea;
